import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
var _class;
import { List } from 'immutable';
import SessionItemResult from '../records/SessionItemResult';
import withCachedArguments from '../util/withCachedArguments';
export function getSessionItemResultsByIds(state) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return ids.reduce(function (list, id) {
    var sessionItem = getSessionItemResultById(state, id);
    return sessionItem ? list.push(sessionItem) : list;
  }, List());
}
export function getSessionItemResultById(state, id) {
  return SessionItemResult.create(state.getIn(['sessionItemResults', "".concat(id)]));
}
var CacheHelper = (_class = /*#__PURE__*/function () {
  function CacheHelper() {
    _classCallCheck(this, CacheHelper);
  }
  return _createClass(CacheHelper, [{
    key: "gradingSessionItemResults",
    value: function gradingSessionItemResults(sessionItemResults, scope) {
      return sessionItemResults.toList().filter(scope);
    }
  }]);
}(), _applyDecoratedDescriptor(_class.prototype, "gradingSessionItemResults", [withCachedArguments], Object.getOwnPropertyDescriptor(_class.prototype, "gradingSessionItemResults"), _class.prototype), _class);
var cacheHelper = new CacheHelper();

// This is a hack to continue using withCachedArguments until we implement reselect
export var getGradingSessionItemResults = cacheHelper.gradingSessionItemResults.bind(cacheHelper);